export default {
  state: {
    timeRange: null,
  },
  mutations: {
    setFlowsTimeRange(state, timeRange) {
      state.timeRange = timeRange;
    },
  },
  actions: {},
  getters: {
    getFlowsTimeRange: (state) => state.timeRange,
  },
};
